import React, { useEffect, useState } from "react";
import { PageHeader } from "./Pengumuman";
import { FileText, Plus, CheckCircle2, Clock } from "lucide-react";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Badge } from "../components/ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "../components/ui/dialog";
import { useApp } from "../context/AppContext";
import { toast } from "sonner";
import { suratAPI } from "../lib/api";

const SuratMenyurat = () => {
  const { user } = useApp();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ jenis: "Surat Pengantar Domisili", keperluan: "" });
  const load = () => suratAPI.list().then(setItems).catch(() => {});
  useEffect(() => { load(); }, []);
  const submit = async () => {
    if (!form.keperluan) { toast.error("Keperluan wajib diisi"); return; }
    try { await suratAPI.create(form); setForm({ jenis: "Surat Pengantar Domisili", keperluan: "" }); setOpen(false); toast.success("Pengajuan dikirim"); load(); } catch { toast.error("Gagal"); }
  };
  const setuju = async (id) => { try { await suratAPI.update(id, { status: "disetujui" }); toast.success("Surat disetujui"); load(); } catch { toast.error("Gagal"); } };
  return (
    <div>
      <PageHeader title="Surat Menyurat" subtitle="Layanan Pengurus RT DM Residence: Administrasi Kependudukan, Surat Keterangan Serba Guna, dan keperluan lain warga" icon={FileText}
        action={<Dialog open={open} onOpenChange={setOpen}><DialogTrigger asChild><Button className="brand-btn"><Plus className="h-4 w-4 mr-1" />Ajukan Surat</Button></DialogTrigger>
          <DialogContent><DialogHeader><DialogTitle>Pengajuan Surat Baru</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div><Label>Jenis Surat</Label><Select value={form.jenis} onValueChange={(v) => setForm({ ...form, jenis: v })}><SelectTrigger><SelectValue /></SelectTrigger><SelectContent>
                <SelectItem value="Surat Pengantar Domisili">Surat Pengantar Domisili</SelectItem>
                <SelectItem value="Surat Keterangan Usaha">Surat Keterangan Usaha</SelectItem>
                <SelectItem value="Surat Pengantar Nikah">Surat Pengantar Nikah</SelectItem>
                <SelectItem value="Surat Keterangan Tidak Mampu">Surat Keterangan Tidak Mampu</SelectItem>
                <SelectItem value="Surat Keterangan Kelahiran">Surat Keterangan Kelahiran</SelectItem>
                <SelectItem value="Surat Keterangan Kematian">Surat Keterangan Kematian</SelectItem>
              </SelectContent></Select></div>
              <div><Label>Keperluan</Label><Textarea rows={3} value={form.keperluan} onChange={(e) => setForm({ ...form, keperluan: e.target.value })} /></div>
            </div>
            <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Batal</Button><Button onClick={submit} className="brand-btn">Ajukan</Button></DialogFooter>
          </DialogContent></Dialog>}
      />
      <Card><CardContent className="p-0">
        <div className="overflow-x-auto"><table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-600 text-xs uppercase"><tr>
            <th className="text-left p-3">Jenis Surat</th><th className="text-left p-3">Pemohon</th><th className="text-left p-3">Keperluan</th><th className="text-left p-3">Tanggal</th><th className="text-center p-3">Status</th><th className="text-right p-3">Aksi</th>
          </tr></thead><tbody>
            {items.map((s) => (
              <tr key={s.id} className="border-t border-slate-100 hover:bg-emerald-50/30">
                <td className="p-3 font-medium text-slate-800">{s.jenis}</td><td className="p-3">{s.pemohon}</td><td className="p-3 text-slate-600">{s.keperluan}</td><td className="p-3 text-slate-600">{s.tanggal}</td>
                <td className="p-3 text-center">{s.status === "disetujui" ? <Badge className="bg-emerald-100 text-emerald-800 hover:bg-emerald-100"><CheckCircle2 className="h-3 w-3 mr-1" />Disetujui</Badge> : <Badge className="bg-amber-100 text-amber-800 hover:bg-amber-100"><Clock className="h-3 w-3 mr-1" />Proses</Badge>}</td>
                <td className="p-3 text-right">{s.status !== "disetujui" && user.role !== "warga" && <Button size="sm" className="brand-btn" onClick={() => setuju(s.id)}>Setujui</Button>}</td>
              </tr>
            ))}
          </tbody></table></div>
      </CardContent></Card>
    </div>
  );
};
export default SuratMenyurat;
